import service from '../utils/request';

/**
 * 创建装车单
 * @param {Object} data - 装车单数据
 * @returns {Promise}
 */
export function createLoadingOrder(data) {
  return service.post('/uic-system_hf/loadingOrder/add', data);
}

/**
 * 获取装车单列表
 * @param {Object} params - 查询参数
 * @param {string} params.orderNo - 订单编号
 * @param {string} params.factoryName - 工厂名称
 * @param {string} params.vehiclePlate - 车牌号
 * @param {string} params.startDate - 开始日期
 * @param {string} params.endDate - 结束日期
 * @param {number} params.current - 页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function getLoadingOrderList(params) {
  return service.get('/uic-system_hf/loadingOrder/page', {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      orderNo: params.orderNo || '',
      factoryName: params.factoryName || '',
      vehiclePlate: params.vehiclePlate || '',
      startDate: params.startDate || '',
      endDate: params.endDate || ''
    }
  });
}

/**
 * 获取装车单详情
 * @param {number} id - 装车单ID
 * @returns {Promise}
 */
export function getLoadingOrderDetail(id) {
  return service.get('/uic-system_hf/loadingOrder/detail', {
    params: {
      id: id
    }
  });
}

/**
 * 添加装车单详情（扫码后）
 * @param {Object} data - 装车单详情数据
 * @returns {Promise}
 */
export function addLoadingOrderDetail(data) {
  return service.post('/uic-system/loadingOrderDetail/save', data);
}

/**
 * 删除装车单详情
 * @param {number} id - 装车单详情ID
 * @returns {Promise}
 */
// 确保deleteLoadingOrderDetail函数的实现正确
export function deleteLoadingOrderDetail(id) {
  // 确保params对象正确包含id参数
  return service.delete('/uic-system_hf/loadingOrder/delete', {
    params: {
      id: id
    }
  });
}

/**
 * 更新装车单状态
 * @param {Object} data - 状态更新数据
 * @returns {Promise}
 */
export function updateLoadingOrderStatus(data) {
  return service.post('/uic-system/loadingOrder/updateStatus', data);
}

/**
 * 获取供应商列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词
 * @returns {Promise}
 */
export function getSuppliers(params) {
  return service.get('/uic-system/supplier/page', {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      supplierName: params.keyword || ''
    }
  });
}

/**
 * 根据编码获取供应商
 */
export function getSupplierByCode(code) {
  return service.get('/uic-system/supplier/page', {
    params: {
      supplierCode: code,
      current: 1,
      size: 1
    }
  });
}

/**
 * 根据供应商和编码获取物料
 */
export function getMaterialBySupplierAndNo(materialNo, supplierId) {
  return service.get('/uic-system/material/page', {
    params: {
      materialNo,
      supplierId,
      current: 1,
      size: 1
    }
  });
}

/**
 * 更新装车单数据（批量保存/更新明细）
 * @param {Object} data - 装车单数据，包含id和details数组
 * @returns {Promise}
 */
export const updateLoadingOrder = (data) => {
  return service.post('/uic-system_hf/loadingOrder/update', data);
}

// 在文件末尾添加
/**
 * 提交装车单（完成装车）
 * @param {number} id - 装车单ID
 * @returns {Promise}
 */
// 提交装车单（完成装车）
export function submitLoadingOrder(id, data = {}) {
  // 确保id同时在请求体中存在
  const requestBody = {
    id: id,  // 添加id到请求体中
    ...data  // 合并其他数据（如车牌号）
  };
  
  return service.post('/uic-system_hf/loadingOrder/submit', requestBody, {
    params: {
      id: id  // 同时作为URL参数传递
    }
  });
}